import { ProjectType } from '../types'

export const projects: ProjectType[] = [
  {
    title: 'ROLF (Robot Golf)',
    images: {
      png: '/images/projects/rolf.png',
      avif: '/images/projects/rolf.avif'
    },
    description: 'Teaching a robot how to play golf, one putt at a time.',
    tags: ['Python', 'MuJoCo', 'PPO'],
    platforms: [{ url: 'https://github.com/JamelHammoud/rolf', label: 'GitHub' }],
    link: {
      url: 'https://github.com/JamelHammoud/rolf',
      label: 'SEE CODE ON GITHUB'
    }
  },
  {
    title: 'Crew',
    images: {
      png: '/images/projects/crew.png',
      avif: '/images/projects/crew.avif'
    },
    description: 'A desktop app that lets you work on a project alongside your agents.',
    tags: ['TypeScript', 'ReactJS', 'Electron'],
    platforms: [{ url: 'https://github.com/JamelHammoud/crew', label: 'GitHub' }],
    link: {
      url: 'https://github.com/JamelHammoud/crew/releases',
      label: 'DOWNLOAD CREW'
    }
  },
  {
    title: 'Paint',
    images: {
      png: '/images/projects/paint.png',
      avif: '/images/projects/paint.avif'
    },
    description: 'A Discord Bot that lets you send painted messages.',
    tags: ['NodeJS', 'DiscordJS', 'ReactJS'],
    platforms: [
      { url: 'https://www.discordpaintbot.com/about', label: 'Web' },
      { url: 'https://github.com/JamelHammoud/paint-bot', label: 'GitHub' },
      {
        url: 'https://www.reddit.com/r/webdev/comments/10zv9v3/i_built_an_opensource_discord_bot_that_lets_you/',
        label: 'Reddit'
      },
      {
        url: 'https://discord.com/api/oauth2/authorize?client_id=1066192909109567489&permissions=296960&scope=bot',
        label: 'Discord'
      }
    ],
    link: {
      url: 'https://discord.com/api/oauth2/authorize?client_id=1066192909109567489&permissions=296960&scope=bot',
      label: 'USE ON DISCORD'
    }
  },
  {
    title: 'Homie',
    images: {
      png: '/images/projects/homie.png',
      avif: '/images/projects/homie.avif'
    },
    description:
      'A fun little web-based game where you guess the sale-value of a home by going through its 3D virtual tour.',
    tags: ['TypeScript', 'ReactJS'],
    platforms: [
      { url: 'https://myhomie.netlify.app/', label: 'Web' },
      {
        url: 'https://www.reddit.com/r/webdev/comments/xz1d21/created_a_fun_reactjs_homevalue_guesser_called/',
        label: 'Reddit'
      }
    ],
    link: {
      url: 'https://myhomie.netlify.app/',
      label: 'PLAY HOMIE'
    }
  },
  {
    title: 'Crosswalk',
    images: {
      png: '/images/projects/crosswalk.png',
      avif: '/images/projects/crosswalk.avif'
    },
    description:
      'Your gateway into the unseen world around you. Drop & discover hidden messages wherever you find yourself.',
    tags: ['TypeScript', 'ReactJS', 'CapacitorJS'],
    platforms: [{ url: 'https://www.crosswalkapp.com/', label: 'Web' }],
    link: {
      url: 'https://www.crosswalkapp.com/',
      label: 'SEE LANDING PAGE'
    }
  },
  {
    title: 'Mamera',
    images: {
      png: '/images/projects/mamera.png',
      avif: '/images/projects/mamera.avif'
    },
    description:
      'A stupidly silly app developed to test CapacitorJS. It can be found on the iOS App Store.',
    tags: ['TypeScript', 'ReactJS', 'CapacitorJS'],
    platforms: [
      { url: 'https://github.com/JamelHammoud/mamera', label: 'GitHub' },
      { url: 'https://apps.apple.com/us/app/mamera/id1600575010', label: 'App Store' }
    ],
    link: {
      url: 'https://apps.apple.com/us/app/mamera/id1600575010',
      label: 'GET ON APP STORE'
    }
  },
  {
    title: 'iHomeroom',
    images: {
      png: '/images/projects/ihomeroom.png',
      avif: '/images/projects/ihomeroom.avif'
    },
    // videoUrl: ihomeroomVideo,
    description:
      'A small online platform to help my teachers stay connected with us during our school closure.',
    tags: ['PHP', 'DigitalOcean', 'MySQL'],
    platforms: [
      {
        url: 'https://www.reddit.com/r/webdev/comments/fmel4i/im_a_student_in_canada_i_created_a_small_online/',
        label: 'Reddit'
      }
    ],
    link: {
      url: 'https://www.reddit.com/r/webdev/comments/fmel4i/im_a_student_in_canada_i_created_a_small_online/',
      label: 'SEE REDDIT POST'
    }
  },
  {
    title: 'Hextime',
    code: `<!DOCTYPE html> <html lang="en"> <head> <title>HexTime</title> <meta charset="utf-8"> <meta name="viewport" content="width=device-width, initial-scale=1"> <meta name="author" content="Jamel Hammoud"/> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta property="og:image" content="https://jamelhammoud.com/img/splash.png" /> <meta property="og:title" content="HexTime"> <meta name="description" content="A clock that represents the time as hex color values"> <meta property="og:type" content="website" /> <link href="https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap" rel="stylesheet"> </head> <body> <style> body { margin: 0; overflow-x: hidden; font-family: 'Quicksand', sans-serif; font-size: 16px; transition: 0.5s; } main { min-height: 100vh; display: flex; align-items: center; justify-content: center; color: white; } h1, p { margin: 0; } h1 { font-size: 16vw; font-weight: 300; } footer { position: fixed; left: 0; right: 0; bottom: 2rem; font-size: 14px; margin: 0 auto; width: fit-content; background: #ffffff17; padding: 6px 13px; border-radius: 50rem; color: #ffffffba; font-weight: 700; } footer a { color: white; text-decoration: none; } footer a:hover { text-decoration: underline; } </style> <main> <section> <h1 id="clock"></h1> </section></main> <script> setInterval(function() { var hex = '#' + new Date().toISOString().substr(11, 8).replace(/:/g, ''); document.getElementById('clock').innerHTML = hex; document.body.style.backgroundColor = hex; }, 500); // 0.5s </script> </body> </html>`,
    videoUrl: 'test',
    description:
      'A fun little JS-powered clock that represents the time as color, using hex values.',
    tags: ['JavaScript', 'HTML'],
    platforms: [
      { url: 'https://github.com/JamelHammoud/hextime', label: 'GitHub' },
      {
        url: 'https://www.reddit.com/r/webdev/comments/ivsw8e/time_displayed_as_color/',
        label: 'Reddit'
      },
      { url: 'https://steamcommunity.com/sharedfiles/filedetails/?id=2234001093', label: 'Steam' }
    ],
    link: {
      url: 'https://github.com/JamelHammoud/hextime',
      label: 'SEE CODE ON GITHUB'
    }
  },
  {
    title: 'DalChess',
    images: {
      png: '/images/projects/dalchess.png',
      avif: '/images/projects/dalchess.avif'
    },
    description:
      'A web application for the Dalhousie Chess Club to keep up-to-date on club events, record your matches and see your auto-generated scores.',
    tags: ['ReactJS', 'TypeScript', 'Firebase'],
    platforms: [{ url: 'https://github.com/JamelHammoud/dal-chess', label: 'GitHub' }],
    link: {
      url: 'https://github.com/JamelHammoud/dal-chess',
      label: 'SEE CODE ON GITHUB'
    }
  },
  {
    title: 'React Boiler',
    images: {
      png: '/images/projects/react-boiler.png',
      avif: '/images/projects/react-boiler.avif'
    },
    description:
      'A template repository containing all the boiler code I need when building React + Typescript projects.',
    tags: ['TypeScript', 'ReactJS', 'Template'],
    platforms: [{ url: 'https://github.com/JamelHammoud/react-boiler', label: 'GitHub' }],
    link: {
      url: 'https://github.com/JamelHammoud/react-boiler',
      label: 'SEE CODE ON GITHUB'
    }
  },
  {
    title: 'Jmoji',
    images: {
      png: '/images/projects/jmoji.png',
      avif: '/images/projects/jmoji.avif'
    },
    description: 'A Discord bot that brings my favorite part of Snapchat (Bitmojis) to Discord.',
    tags: ['NodeJS', 'DiscordJS']
  },
  {
    title: 'Echo',
    images: {
      png: '/images/projects/echo.png',
      avif: '/images/projects/echo.avif'
    },
    description:
      'A web-based workspace that allows you to instantly create, share and collaborate on code.',
    tags: ['PHP', 'DigitalOcean', 'MySQL']
  }
  // {
  //   title: 'Atlantic Convenience Expo',
  //   imageUrl: '',
  //   videoUrl: 'test',
  //   description: 'A web application for ACE\'s virtual expo. Attendees can browse exhibitor\'s profiles, claim show deals and attend pre-recorded seminars.',
  //   tags: ['PHP', 'MySQL', 'JavaScript']
  // },
  // {
  //   title: 'JamCord',
  //   imageUrl: '',
  //   description: 'A Discord clone for my friends.',
  //   tags: ['ReactJS', 'JavaScript'],
  //   platforms: [
  //     { url: '', label: 'GitHub' }
  //   ],
  //   link: {
  //     url: 'https://github.com/JamelHammoud/hextime',
  //     label: 'SEE CODE ON GITHUB'
  //   }
  // },
  // {
  //   title: 'Covid Digest',
  //   imageUrl: '',
  //   description: 'A website that tracks cases, deaths, news articles and videos relating to the Coronavirus.',
  //   tags: ['PHP', 'JavaScript', 'Cloudflare']
  // },
  // {
  //   title: 'Twiist',
  //   imageUrl: '',
  //   videoUrl: twiistVideo,
  //   description: 'A web application that allows you to stream, interact with & upload videos.',
  //   tags: ['PHP', 'MySQL', 'JavaScript']
  // },
  // {
  //   title: 'RetailID',
  //   imageUrl: '',
  //   videoUrl: retailidVideo,
  //   description: 'A website that tracks cases, deaths, news articles and videos relating to the Coronavirus.',
  //   tags: ['PHP', 'MySQL', 'JavaScript']
  // },
  // {
  //   title: 'FileUp',
  //   imageUrl: '',
  //   description: 'A website that lets you upload a file & share the public (or private) link with anybody (you can also view metric on shares / downloads).',
  //   tags: ['PHP', 'MySQL', 'JavaScript']
  // },
  // {
  //   title: 'Team Banana',
  //   imageUrl: '',
  //   description: 'A website that aims to solve the debate once and for all: bananas are a dessert.',
  //   tags: ['PHP', 'MySQL', 'JavaScript']
  // }
]
